import { PopupType } from '../../../components/popup/types';
import { RoundIntegrityWatcher, RoundIntegrityWatcherPhases } from '../../../logger/RoundIntegrityWatcher';
import type { CoreStoreType } from '../../../store/CoreStore';
import { betActions } from '../../../store/slices/bets/slice';
import type { BetType } from '../../../store/slices/bets/types';
import { GameStatus } from '../../../store/slices/game';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import { crossOriginCommunicationController } from '../../crossOriginCommunication/CrossOriginCommunicationControllerConnector';
import { OutgoingMessage } from '../../crossOriginCommunication/types';
import { GameCommunicationBetSender } from '../senders/GameCommunicationBetSender';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

import { GameCommunicationLowBalanceAwareProcessor } from './GameCommunicationLowBalanceAwareProcessor';

const betSender = new GameCommunicationBetSender();

export class GameCommunicationBetsOpenProcessor
  extends GameCommunicationLowBalanceAwareProcessor
  implements IGameCommunicationProcessor
{
  messageName = 'betsopen';

  process(message: GameCommunicationMessageType, store: CoreStoreType): void {
    RoundIntegrityWatcher.setPhase(RoundIntegrityWatcherPhases.BetsOpen);

    crossOriginCommunicationController.dispatch(OutgoingMessage.RoundStart);

    if (this.checkLowBalanceAndUpdateState(store)) {
      const balanceCheckCount = store.getState().gameState.balanceCheckCount;
      if (balanceCheckCount > 3) {
        store.dispatch(popupActions.pushPopup(PopupType.InsufficientFunds));
      } else {
        store.dispatch(gameStateActions.setBalanceCheckCount(balanceCheckCount + 1));
      }
    }

    this.checkAutoplayAvailability(store);

    store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.PlaceYourBets));
    store.dispatch(betActions.resetBetStack());
    store.dispatch(gameStateActions.resetForNewGame());

    this.placeAutoplayBet(store);
  }

  protected placeAutoplayBet(store: CoreStoreType): void {
    const { autoplay, bets, gameState } = store.getState();
    if (autoplay.isInProgress) {
      const balance = gameState.userInfo?.balance;
      const deductibleBalance = (balance?.amount ?? 0) + (balance?.bonus ?? 0);
      const disabledBets = bets.disabledBetSpots ?? [];
      const savedBet = autoplay.savedBet;
      const newBet: BetType = { betSpots: {} };

      for (const betId in savedBet!.betSpots) {
        if (savedBet!.betSpots[betId].value > 0 && !disabledBets.includes(betId)) {
          newBet.betSpots[betId] = savedBet!.betSpots[betId];
        }
      }

      store.dispatch(
        betActions.pushBet({
          bet: newBet,
          balance: deductibleBalance,
          decimals: gameState.currencyInfo?.digitsNumber ?? 2,
        })
      );
      betSender.dispatch();
      store.dispatch(popupActions.dismissPopup(PopupType.AutoplayModified));
    }
  }
}
